import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { didUserHaveAssociatedClientError } from "../common/clientHelper";
import { toast } from "react-toastify";

class NoDataPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        if (didUserHaveAssociatedClientError()) {
            toast(<FormattedMessage id="clients.unauthorizedRedirectedExternalUser" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        }
    }

    render() {
        return (
            <div className="no-data-page">
                <div className="content-container">
                    <h1 className="title">
                        <FormattedMessage id="error.noData.title" />
                    </h1>

                    <p className="description">
                        <FormattedMessage id="error.noData.description" />
                    </p>

                    <Link to="/" className="go-home-link">
                        <FormattedMessage id="error.noData.link" />
                    </Link>
                </div>
            </div>
        );
    }
}

export default NoDataPage;



// WEBPACK FOOTER //
// ./src/components/app/NoDataPage.js